import React from 'react'

import { Button } from 'shared/components'
import { getContactCenterPhone, getHotlinePhone } from 'shared/utils'

import classes from './Hotline.module.scss'

const formLink = '//hotline-mts.b1.ru/Issue/Create'
const mail = 'external.hotline.mts@b1.ru'
const phoneHotline = getHotlinePhone()
const phoneContacts = getContactCenterPhone()
const url = 'hotline-mts.b1.ru'

export const Hotline: React.FC = () => {
  return (
    <div
      className={`row ${classes.row} reveal-from-bottom-medium`}
      data-reveal-delay={15}
    >
      <div className="col-xs-12">
        <h2 className={`mb-1 ${classes.title}`}>
          «Единая горячая линия» Группы МТС
        </h2>
      </div>

      <div className="col-lg-6 col-md-12 col-xs-12">
        <p className={classes['max-width']}>
          Для сообщений о потенциальных или совершенных нарушениях положений
          Кодекса делового поведения и этики, коррупции и мошенничества и иных
          нарушений законодательства, связанных со сферой деятельности компании,
          пишите по адресу:{' '}
          <a href={`mailto:${mail}`} className="link color nowrap">
            {mail}
          </a>{' '}
          или номеру:{' '}
          <a href={`tel:${phoneHotline.href}`} className="link color nowrap">
            {phoneHotline.text}
          </a>
          , бесплатному для звонков с территории РФ. Мы также предусмотрели
          возможность бесплатных звонков из-за рубежа, инструкции размещены на
          сайте{' '}
          <a
            href={`https://${url}`}
            target="_blank"
            rel="noreferrer"
            className="link color nowrap"
          >
            {url}
          </a>
          . Обращаем ваше внимание, что телефонная линия обслуживается
          независимой третьей стороной. Вы также можете сообщить о фактах
          нарушений, заполнив простую форму на сайте.
        </p>
        <a target="_blank" rel="noreferrer" href={formLink}>
          <Button size="medium" className={`mb-2 mt-2 ${classes.btn}`}>
            Заполнить форму
          </Button>
        </a>
        <span className={`${classes['max-width']} ${classes.note}`}>
          При приеме и рассмотрении обращений компания гарантирует
          конфиденциальность и неразглашение персональных данных обратившихся.
          Компания обязуется не допускать ответных действий в отношении
          добросовестных лиц, сообщающих о нарушениях. Вы также можете сообщить
          о нарушениях анонимно. При этом следует помнить, что не допускается
          умышленное предоставление ложной или вводящей в заблуждение
          информации.
        </span>
      </div>

      <div className="col-lg-6 col-md-12 col-xs-12">
        <p className={`${classes['max-width']} mb-2`}>
          Жалобы на технические неполадки, а также претензии, связанные с
          качеством предоставляемых услуг, не рассматриваются в рамках работы
          данной линии. Пожалуйста, для этих целей обращайтесь в Контактный
          центр по телефону:{' '}
          <a href={`tel:${phoneContacts.href}`} className="link color nowrap">
            {phoneContacts.text}
          </a>
        </p>
        <p className={classes['max-width']}>
          Если у вас возникли вопросы в области Кодекса делового поведения и
          этики, антикоррупционного законодательства или другие вопросы по темам
          комплаенс, вы можете направить их по адресу:{' '}
          <a
            href="mailto:compliance_media@mts.ru"
            className="link color nowrap"
          >
            compliance_media@mts.ru
          </a>
        </p>
      </div>
    </div>
  )
}
